export const clamp = (min: number, number: number, max: number) => Math.max(min, Math.min(number, max));
